export function formatWhatsAppPersonName(personName) {
    const fullName = (personName || '').trim();
    if (!fullName) {
        return '';
    }

    const firstName = fullName.split(/\s+/)[0];
    if (!firstName) {
        return '';
    }

    return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
}

export function buildDefaultWhatsAppMessage(personName) {
    const name = formatWhatsAppPersonName(personName);
    if (!name) {
        return 'Olá';
    }
    return `Olá, ${name}`;
}

export function normalizeBrazilPhone(phoneNumber) {
    if (phoneNumber === undefined || phoneNumber === null) {
        return null;
    }

    const digits = String(phoneNumber).replace(/\D/g, '');
    if (!digits) {
        return null;
    }

    if (digits.startsWith('55') && digits.length >= 12) {
        return digits;
    }

    return `55${digits}`;
}

export function buildWhatsAppUrl(phoneNumber, message) {
    const phoneOnlyNumbers = normalizeBrazilPhone(phoneNumber);
    if (!phoneOnlyNumbers) {
        return null;
    }

    let url = `https://api.whatsapp.com/send?phone=${phoneOnlyNumbers}`;
    if (message) {
        url += `&text=${encodeURIComponent(message)}`;
    }

    return url;
}

export function openWhatsAppChat(phoneNumber, message) {
    const url = buildWhatsAppUrl(phoneNumber, message);
    if (!url) {
        return false;
    }

    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
}
